/**
 * Quick 260813-iqd — mutation hook for the self-service personal email
 * (PATCH /api/auth/me/personal-email). Mirrors useBotConnection.ts:
 * useMutation + useErrorToast. No query-key invalidation here — the caller
 * (PersonalEmailSection) refreshes auth state via refreshUser() so
 * GET /api/auth/me re-populates authContext.user.personalEmail.
 */
import { useMutation } from '@tanstack/react-query';
import { useErrorToast } from './queryUtils';
import { updatePersonalEmail } from '../services/api/personalEmail';

export function useUpdatePersonalEmail() {
  const onError = useErrorToast();
  return useMutation({
    mutationFn: (personalEmail: string | null) => updatePersonalEmail(personalEmail),
    onError: (err) => onError(err, "Couldn't save your personal email"),
  });
}
